import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import useAsync from "../hooks/useAsync";
import ReviewServices from "../services/ReviewServices";
import ViewReview from "./View Model/ViewReview";
import DeleteButton from "./Button/DeleteButton";
import ReviewStatus from "./TogelButton/RatingStatus";
import Modal from "react-modal";
import ReactPaginate from "react-paginate";
import StarRating from './Rating/StarRating';
import Pagetitle from "./PageTitle";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";

Modal.setAppElement("#root");

function ManageReview() {
  const { data, error, isLoading, run } = useAsync(ReviewServices.getReview);
  console.log(data);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [userTypeFilter, setUserTypeFilter] = useState("");
  const [planFilter, setPlanFilter] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(data?.data || []);
  const [ratingFilter, setRatingFilter] = useState(""); // For rating filter
  const [statusFilter, setStatusFilter] = useState(""); // For status filter
  const [filteredReview, setFilteredReview] = useState([]);


  const reviewPerPage = 10;
  const handleViewDetails = (review) => {
    setSelectedUser(review);
    setIsModalOpen(true);
  };

  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };
  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
  };
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  // Define closeModal function for closing the ViewUser modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' }); // Get abbreviated month name
    const year = date.getFullYear().toString();

    return `${day} ${month} ${year}`;
  };

  useEffect(() => {
    if (data?.data) {
      const filtered = data.data.filter((review) => {
        const matchesSearch =
          (review?.user?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          review?.investor?.name?.toLowerCase().includes(searchQuery.toLowerCase())) ?? false;
  
        const matchesRating = ratingFilter
          ? review.rating === parseInt(ratingFilter)
          : true;
  
        const matchesStatus = statusFilter
          ? review.status === statusFilter
          : true;
  
        return matchesSearch && matchesRating && matchesStatus;
      });
  
      setFilteredReview(filtered);
    }
  }, [data, searchQuery, ratingFilter, statusFilter]);
  

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleRatingChange = (e) => {
    setRatingFilter(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };


  // Calculate pagination values
  const indexOfLastUser = currentPage * reviewPerPage;
  const indexOfFirstUser = indexOfLastUser - reviewPerPage;
  const paginatedReview = filteredReview?.slice(
    indexOfFirstUser,
    indexOfLastUser
  ); // Slice the filtered users for pagination

  function truncateText(text, limit) {
    const words = text.split(' ');
    return words.length > limit ? words.slice(0, limit).join(' ') + '...' : text;
  }



  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box px-0 user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search by Name"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <button className="search-btn">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>
          <div className="sub-title-box-right d-flex">
            <div>
              <select
                value={ratingFilter}
                onChange={handleRatingChange}
                style={{ backgroundColor: "#fff" }}
              >
                <option value="">Rating</option>
                <option value="1">1 Star</option>
                <option value="2">2 Star</option>
                <option value="3">3 Star</option>
                <option value="4">4 Star</option>
                <option value="5">5 Star</option>
              </select>
            </div>
            <div className="ms-3">
              <select
                value={statusFilter}
                onChange={handleStatusChange}
                style={{ backgroundColor: "#fff" }}
              >
                <option value="">Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>
        </div>
        <div className="container-box-inner">
          <table
            id="example"
            className="table table-striped"
            style={{ width: "100%" }}
          >
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Image</th>
                <th>User Type</th>
                <th>User Name</th>
                <th>Cottage Name</th>
                <th>Rating</th>
                <th>Review Text</th>
                <th>Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedReview?.map((review, index) => (
                <tr key={review?._id}>
                  <td>{index + 1 + (currentPage - 1) * reviewPerPage}</td>
                  <td>
                    <div className="product-img">
                      <img
                        src={process.env.REACT_APP_URL + review?.image}
                        alt=""
                        style={{ height: '70px', width: '70px', objectFit: 'contain' }}
                      />
                    </div>
                  </td>
                  <td>{review?.userType ? review.userType: 'N/A'}</td>
                  <td>{review?.user?.name ? review.user.name :  review.investor.name}</td>
                  <td>{review?.cottage?.name || 'N/A'}</td>
                  <td>
                    <StarRating rating={review?.rating} />
                  </td>
                  <td>{truncateText(review?.comment, 20)}</td>
                  <td>{formatDate(review?.createdAt)}</td>
                  <td className="status-toggle">
                    <ReviewStatus data={review} page={'review'} onSuccess={run} />
                  </td>
                  <td>
                    <div className="action_toggle_outer">
                      <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li>
                              <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                <i className="fa fa-close" />
                              </button>
                            </li>
                            <li>
                              <button className="edit" onClick={() => handleViewDetails(review)}>View</button>
                            </li>
                            <li>
                              <button className="reject" onClick={() => handleDelete(review)}>Delete</button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}


            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredReview?.length || 0) / reviewPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={"page-link"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
            pageClassName={"page-item"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            disabledClassName={"disabled"}
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewReview review={selectedUser} closeModal={closeModal} onSuccess={run} />
      </Modal>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton
          data={selectedEdit}
          page="review"
          closeModal={closeDeleteModal}
          onSuccess={run}
        />
      </Modal>
    </div>
  );
}

export default ManageReview;
